import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'

function LocaleChecked(props) {
  const { i18n } = useTranslation();
  const [isEn, setIsEn] = useState()
  useEffect(() => {
    const l = localStorage.getItem('locale');
    
    i18n.changeLanguage(l ? l.toLocaleLowerCase() : 'KO')
    setIsEn(l);
  }, [])

  const handleEnOnOff = useCallback((e) => {
    const checked = e.target.checked;
    let locale = 'KO';
    if (checked) locale = 'EN';
    localStorage.setItem('locale', locale);
    // setIsEn(locale);
    // i18n.changeLanguage(locale.toLocaleLowerCase());
    // alert(locale);
    window.location.href = `/selectLearning?LOCALE=${locale.toLowerCase()}&CHN_CD=GLOBAL01&LAUNCH_TYPE=GLOBAL01`
  }, [])
  
  return (
    <div 
      className="custom-radio-wrap gray"
      style={{
        position: 'absolute',
        top: 20,
        left: 100,
      }}
    >
      <input
        type="checkbox"
        id="login_chk"
        name="isEn"
        checked={isEn === 'EN'}
        onChange={handleEnOnOff}
      />
      <label style={{ color: 'black' }} htmlFor="login_chk">영문 On/Off</label>
    </div>
  );
}

export default LocaleChecked;